<template>
  <div class="is_headapp">
    <h1>Отправка в транзит</h1>
    <pre v-if="0">
      boxes: {{boxes}}
    </pre>
    <template v-if="success">
      <p style="font-weight: bold; color: green;">Статус заказа успешно изменён</p>
    </template>
    <template v-else>
      <template v-if="!plomb_code">
          <p>
            <b>Шаг1</b><br>
            Введите или отсканируйте пломбу:
          </p>
          <v-text-field 
            v-model="value"
            autofocus
            @keyup.enter="scan_plomb"
            label="Введите код"
          />
      </template>
      <template v-if="plomb_code">
          <p>
            <a href="" @click.prevent="plomb_code=''; boxes=[]"><v-icon x-small>fa fa-arrow-left</v-icon> назад</a><br>
            <b>Шаг 2</b>
            <br>
            Вы отсканировали пломбу <b>{{plomb_code}}</b>. Теперь отсканируйте места (по номеру места):
          </p>
          <v-text-field 
            v-model="value"
            autofocus
            @keyup.enter="scan_box"
            label="Введите код"
          />
        
          <template v-if="boxes.length">
            <table class="tbl1">
              <tr class="h">
                <td><b>Номер места</b></td>
                <td><b>Старый код пломбы</b></td>
                <td><b>Описание</b></td>
                <td>&nbsp;</td>
              </tr>
              <tr v-for="(l,idx) in boxes">
                  <td>
                    №{{l.num_place}}
                    <div v-if="!l.id" style="color: red;">не было зарегистрировано ранее</div>
                  </td>
                  <td>{{l.plomb_code}}</td>
                  <td><v-textarea v-model="l.body" label="Описание" /></td>
                <td class="actions"><a href="" @click.prevent="delete_from_list(idx)"><v-icon small  color="primary" icon >delete</v-icon></a></td>
              </tr>
            </table>
            <div style="margin-top: 20px;">
              <v-btn @click="accept_all()" :disabled="!boxes.length">Отправить в транзит{{boxes.length?` (${boxes.length})`:''}}</v-btn>
            </div>
            <p v-if="accept_all_error" style="margin-top: 10px; font-weight: bold; color: red">{{accept_all_error}}</p> <!-- ошибка при подтверждении -->
          </template>
      </template>

    </template>
  </div>

</template>

<script>
import { fixBarcode} from '../js/fixBarcode.js';
export default {
  data(){
    return {
      num:0, // для отложенного ajax-а
      value:'', // код пломбы или номер места для сканирования
      plomb_code:'', // код пломбы после сканирования
      //order:null, // отсканированная заявка
      list:[ // сканированные box-ы
        /*{type:'order',id:1},
        {type:'box',num_place:'76176276', id:1},*/
      ],
      sounds: {
          success: null,
          fail: null,
      },
      success: false, // сообщение об успешном добавлении
      accept_all_error: '', // сообщение об ошибке при добавлении "пропикиваний"
      boxes:[]
    }
  },
  created(){
    let t=this
    t.sounds.success = new Audio('/delivery/success.ogg');
    t.sounds.fail = new Audio('/delivery/fail.ogg');
    // t.$nextTick(() => {
    //   t.$refs.barcodeInput.focus();
    // });
  },
  methods:{
    sound_success(){
      this.sounds.success.currentTime = 0; // Перемотка на начало, если звук уже играл
      this.sounds.success.play().catch(e => console.error("Ошибка воспроизведения:", e));
    },
    sound_fail(){
      this.sounds.fail.currentTime = 0; // Перемотка на начало, если звук уже играл
      this.sounds.fail.play().catch(e => console.error("Ошибка воспроизведения:", e));
    },
    delete_from_list(idx){
      // удаляет из списка позицию
      this.boxes.splice(idx,1)
    },
    scan_plomb(){
      let t=this
      t.value=t.value.replace(/\s+/,'').replace(/\s+$/,'')
      if(!t.value){
        return 
      }
      t.sound_success()
      t.plomb_code=t.value
      t.value=''
    },

    scan_box(){
      let t=this
      t.value=t.value.replace(/\s+/,'').replace(/\s+$/,'')
      console.log('value: ',t.value)
      if(!t.value){
        return 
      }
      t.num++

      setTimeout(
        ()=>{
          t.num--
          console.log('num: ',t.num)
          if(!t.num){ // поиск 
            t.$http.post(BackendBase+'/delivery/to-transit/scan-box',{
              value: t.value
            }).then(
              r=>{
                let d=r.data
                
                if(d.success){
                  
                  if(d.box){ // место найдено
                    t.boxes.push(d.box)
                    t.sound_success()
                  }
                  else{
                    // место не найдено
                    t.sound_fail()
                  }
                  t.value=''
                }
              }
            )
          }
        },
        300
      )
    },

    accept_all(){ // отравляется в приёмку накликанный список
      let t=this
      // показывает сообщение об ошибке
      const show_error=(error)=>{
        t.accept_all_error=error
        setTimeout( ()=>{ t.accept_all_error=false },900 )
      }

      t.$http.post(
        BackendBase+'/delivery/to-transit/accept-boxes',
        {
          list:t.boxes,
          plomb_code: t.plomb_code
        }
      ).then(
        r=>{
          let d=r.data
          if(d.success){
            t.success=true
            setTimeout(
              ()=>{
                t.boxes=[]
                t.plomb_code=null
                t.success=false
              },900
            )
          }
          else if(d.error){
            show_error(d.error)
          }
        }
      )
      
    },
  },
  watch:{
    value(){
      if(this.value){
        this.value=fixBarcode(this.value)
      }
    }
  }
}
</script>

<style scoped>
  .is_headapp {margin: 20px; max-width: 1400px;}
  .is_headapp h1 {margin-bottom: 20px;} 
  .order, .box {border: 1px solid gray; padding: 20px; margin-bottom: 20px; border-radius: 15px;  font-weight: bold;}
  .order {background-color: #3f674a;}
  .box {background-color: #71be86;}
  td.actions {width: 0px;}
</style>